<div
  class="flex items-center p-4 mb-4 text-sm text-blue-800 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400"
  role="alert"
  *ngIf="type === 'info'"
>
  <app-system-icon *ngIf="icon" [iconName]="icon" iconType="solid"></app-system-icon>
  <span class="sr-only">Info</span>
  <div>
    <span class="font-bold">{{ title | translate }}</span>
    {{ message | translate }}
  </div>
</div>
<div
  class="flex items-center p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
  role="alert"
  *ngIf="type === 'danger'"
>
  <app-system-icon *ngIf="icon" [iconName]="icon"></app-system-icon>
  <span class="sr-only">Info</span>
  <div>
    <span class="font-bold">{{ title | translate }}</span>
    {{ message | translate }}
  </div>
</div>
<div
  class="flex items-center p-4 mb-4 text-sm text-green-800 rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400"
  role="alert"
  *ngIf="type === 'success'"
>
  <app-system-icon *ngIf="icon" [iconName]="icon"></app-system-icon>
  <span class="sr-only">Info</span>
  <div>
    <span class="font-bold">{{ title | translate }}</span>
    {{ message | translate }}
  </div>
</div>
<div
  class="flex items-center p-4 mb-4 text-sm text-yellow-800 rounded-lg bg-yellow-50 dark:bg-gray-800 dark:text-yellow-300"
  role="alert"
  *ngIf="type === 'warning'"
>
  <app-system-icon *ngIf="icon" [iconName]="icon"></app-system-icon>
  <span class="sr-only">Info</span>
  <div>
    <span class="font-bold">{{ title | translate }}</span>
    {{ message | translate }}
  </div>
</div>
